<!-- Child Component HTML -->
<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <button
    class="py-1 px-5 border border-[#d9d9d9] rounded"
    (click)="onGroupMapClick()"
    [disabled]="!isGroupMapEnabled"
    [ngClass]="{
      'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]': isGroupMapEnabled,
      'bg-white text-gray-800 cursor-not-allowed': !isGroupMapEnabled
    }"
    pTooltip="{{ groupMapTooltip }}"
    tooltipPosition="top"
  >
    Group Map
  </button>
  <!-- Insider Name input -->
<input
  (keydown.enter)="onSearch()"
  [(ngModel)]="insiderName"
  type="text"
  placeholder="Search by insider name"
  class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
  (keydown)="preventSpaceKey($event)"
  (paste)="onPaste($event, 'insiderName')"
/>

<!-- Issuer Name input -->
<input
  (keydown.enter)="onSearch()"
  [(ngModel)]="issuerName"
  type="text"
  placeholder="Search by issuer name"
  class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
  (keydown)="preventSpaceKey($event)"
  (paste)="onPaste($event, 'issuerName')"
/>

<!-- Reporting Entity Name input -->
<input
  (keydown.enter)="onSearch()"
  [(ngModel)]="reportingEntityName"
  type="text"
  placeholder="Search by entity name"
  class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
  (keydown)="preventSpaceKey($event)"
  (paste)="onPaste($event, 'reportingEntityName')"
/>

<!-- Reporting Entity Type select -->
<select
  [(ngModel)]="selectedReportingEntityType"
  (change)="onSearch()"
  class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
>
  <option [ngValue]="undefined">Select reporting entity type</option>
  <option *ngFor="let type of reportingEntityTypes" [ngValue]="type">
    {{ type }}
  </option>
</select>

</div>




<div class="mb-4"></div>
<div>
  <p-table
    [value]="unprocessedInsiders"
    [paginator]="unprocessedInsiders.length > 0"
    [first]="First"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [rows]="paginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChange($event)"
    [(selection)]="selectedInsiders"
    dataKey="asReportedInsiderId"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>Id</th>
        <th>Insider Name</th>
        <th>Reporting Entity Name</th>
        <th>Reporting Entity Type</th>
        <th>Insider Role In Entity</th>
        <th>Issuer Name</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-insider>
      <tr>
        <td>
          <p-tableCheckbox [value]="insider" />
        </td>
        <td>{{ insider.asReportedInsiderId || "N/A" }}</td>
        <td>{{ insider.asReportedInsiderName || "N/A" }}</td>
        <td
          style="
            max-width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          <span
            [pTooltip]="insider.asReportedReportingEntityName"
            tooltipPosition="top"
            [tooltipStyleClass]="'custom-tooltip'"
            [autoHide]="false"
            [tooltipDisabled]="!insider.asReportedReportingEntityName"
            class="block overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ insider.asReportedReportingEntityName || "N/A" }}
          </span>
        </td>
        <!-- <td>{{ insider.asReportedReportingEntityName || "N/A" }}</td> -->
        <td>{{ insider.asReportedReportingEntityType || "N/A" }}</td>
        <td>{{ insider.asReportedInsiderRoleInEntity || "N/A" }}</td>
        <td>{{ insider.asReportedIssuerName || "N/A" }}</td>

        <td>
          <button
            class="bg-white cursor-pointer hover:bg-gray-100 text-gray-800 py-1 px-3 border border-gray-400 rounded"
            (click)="openMapModal(insider, $event)"
          >
            Map
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
